import { defineMessages } from 'react-intl';

export default defineMessages({
    continue: {
        id: 'ml.quoteandbind.pa.prefill.agentSelection.Continue',
        defaultMessage: 'Continue'
    },
    cancel: {
        id: 'ml.quoteandbind.pa.prefill.agentSelection.Cancel',
        defaultMessage: 'Cancel'
    },
    indicativeQuoteFailure: {
        id: 'ml.gateway.quoteandbind.pa.prefill.indicativeQuoteFailure',
        defaultMessage: 'We are unable to retrieve an indicative quote at this time. Please go to ForemostSTAR® for a full rate quote.'
    }
   
});
